/**
 * A record key (task number, project code) as displayed. Codes generated
 * before the generator learned to skip emoji can hold half of one (a lone
 * surrogate, shown as "�"); drop those characters rather than render them.
 */
export function cleanRecordIdentifier(identifier: string): string {
  return identifier
    .replace(
      /�|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?<![\uD800-\uDBFF])[\uDC00-\uDFFF]/g,
      '',
    )
    .trim()
}
